export enum TimerColors {
  ORANGE = 'orange',
  GREEN = 'green',
  NONE = 'none',
  TRANSPARENT = 'transparent',
}
